import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Generates a stable key string from an array of objects based on specified fields.
 * Useful for React keys when you need to force re-renders on data changes.
 */
export function generateDataKey<T extends Record<string, unknown>>(
  items: T[] | null | undefined,
  fields: (keyof T)[],
): string {
  if (!items || items.length === 0) {
    return "empty";
  }

  return items
    .map((item) =>
      fields
        .map((field) => `${String(field)}:${String(item[field])}`)
        .join("|"),
    )
    .join(",");
}
